import React from "react";

type IconProps = { className?: string };

/** Filled star — same glyph as the ratings accordion (18x18). */
export const StarIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 18 18"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M9 1.125L11.0287 5.99727L16.2941 6.42714L12.2812 9.87398L13.5106 15.0104L9 12.2681L4.48939 15.0104L5.71875 9.87398L1.70589 6.42714L6.97129 5.99727L9 1.125Z" />
  </svg>
);

/** Chevron pointing right; rotate via CSS for the other directions. */
export const ChevronRightIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M6 3.625L10.375 8L6 12.375"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
